/** prefix ສຳລັບຕົວກອງຄ່າຕົວເລືອກຕໍ່ option — ບໍ່ໃຊ້ ':' ເພື່ອຫຼີກລ້ຽງ search params ຜິດພາດ */
export const STOCK_FILTER_OPTION_FIELD_PREFIX = "stockOpt_" as const;

const LEGACY_STOCK_FILTER_OPTION_PREFIX = "stockOpt:" as const;

export function stockFilterOptionField(optionId: string): string {
  return `${STOCK_FILTER_OPTION_FIELD_PREFIX}${optionId}`;
}

/** ຄືນ optionId ຖ້າ field ເປັນຕົວກອງ option ຂອງສະຕ໋ອກ */
export function parseStockOptionFilterField(field: string): string | undefined {
  if (field.startsWith(STOCK_FILTER_OPTION_FIELD_PREFIX)) {
    const id = field.slice(STOCK_FILTER_OPTION_FIELD_PREFIX.length);
    return id.length > 0 ? id : undefined;
  }
  if (field.startsWith(LEGACY_STOCK_FILTER_OPTION_PREFIX)) {
    const id = field.slice(LEGACY_STOCK_FILTER_OPTION_PREFIX.length);
    return id.length > 0 ? id : undefined;
  }
  return undefined;
}

export function isStockOptionFilterField(field: string): boolean {
  return parseStockOptionFilterField(field) !== undefined;
}
